<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <a-tabs v-model="activeCode" @change="loadCms">
        <a-tab-pane v-for="item in cmsTabs" :key="item.code" :tab="item.label" />
      </a-tabs>
      <a-spin :spinning="loading">
        <a-form-model :model="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
          <a-form-model-item label="标题">
            <a-input v-model="form.title" placeholder="页面标题" />
          </a-form-model-item>
          <a-form-model-item label="内容">
            <editor v-model="form.content" />
          </a-form-model-item>
          <a-form-model-item :wrapper-col="{ span: 20, offset: 3 }">
            <a-button type="primary" :loading="submitLoading" @click="submitForm">保存</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-spin>
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { getCms, saveCms } from '@/api/giftcard/cms'
import Editor from '@/components/Editor'

export default {
  name: 'GiftcardCms',
  components: { Editor },
  data() {
    return {
      loading: false,
      submitLoading: false,
      activeCode: 'privacy',
      cmsTabs: [
        { code: 'privacy', label: '隐私政策' },
        { code: 'register_agreement', label: '注册协议' },
        { code: 'about_us', label: '关于我们' },
        { code: 'withdraw_rule', label: '提现规则' },
        { code: 'referral_rule', label: '推广规则' }
      ],
      form: { id: null, code: 'privacy', title: '', content: '' }
    }
  },
  created() {
    this.loadCms(this.activeCode)
  },
  methods: {
    loadCms(code) {
      this.activeCode = code
      this.loading = true
      getCms(code).then(res => {
        const data = res.data || {}
        this.form = {
          id: data.id || null,
          code: code,
          title: data.title || this.tabLabel(code),
          content: data.content || ''
        }
      }).finally(() => { this.loading = false })
    },
    tabLabel(code) {
      const tab = this.cmsTabs.find(t => t.code === code)
      return tab ? tab.label : code
    },
    submitForm() {
      if (!this.form.title) {
        this.$message.warning('请输入标题')
        return
      }
      this.submitLoading = true
      saveCms(this.form).then(() => {
        this.$message.success('保存成功')
        this.loadCms(this.activeCode)
      }).finally(() => { this.submitLoading = false })
    }
  }
}
</script>
